import React, { Component } from "react"
import PropTypes from "prop-types"
import { Translate } from "react-localize-redux"
import classnames from "classnames"

import Select from "react-select"
import ValidationMessage from "../forms/ValidationMessage"

let i = 1
const days = []
for (i = 1; i <= 31; i++) {
	days.push({ value: String(i).padStart(2, 0), label: String(i).padStart(2, 0) })
}
const months = []
const monthEngNames = {
	1: "January",
	2: "February",
	3: "March",
	4: "April",
	5: "May",
	6: "June",
	7: "July",
	8: "August",
	9: "September",
	10: "October",
	11: "November",
	12: "December",
}
const vnMonths = []
const monthVnNames = {
	1: "Tháng một",
	2: "Tháng hai",
	3: "Tháng ba",
	4: "Tháng tư",
	5: "Tháng năm",
	6: "Tháng sáu",
	7: "Tháng bảy",
	8: "Tháng tám",
	9: "Tháng chín",
	10: "Tháng muời",
	11: "Tháng mười một",
	12: "Tháng mười hai",
}
for (i = 1; i <= 12; i++) {
	months.push({ value: String(i).padStart(2, 0), label: monthEngNames[i] })
	vnMonths.push({ value: String(i).padStart(2, 0), label: monthVnNames[i] })
}
const years = []
const currentYear = new Date().getFullYear()
for (i = currentYear; i > currentYear - 100; i--) {
	years.push({ value: i, label: i })
}
const getDateValue = (value, selectedValue, type) => {
	const parts = value.split("/")
	let day = parts[0]
	let month = parts[1]
	let yearTime = parts[2].split(" ")
	let year = yearTime[0]
	let time = yearTime[1] ? yearTime[1] : "23:00:00"

	switch (type) {
		case "day":
			day = selectedValue
			break
		case "month":
			month = selectedValue
			break
		case "year":
			year = selectedValue
			break
		default:
			console.log(selectedValue)
			break
	}
	const updatedValue = `${day}/${month}/${year} ${time}`
	return value !== updatedValue ? updatedValue : null
}

class DatePickerField extends Component {
	// constructor(props) {
	// 	super(props)
	// 	this.handleOnBlur = this.handleOnBlur.bind(this)
	// 	this.handleOnChange = this.handleOnChange.bind(this)
	// }

	handleOnBlur = (selectedValue, type) => {
		const { value, onBlur } = this.props.input
		const newValue = getDateValue(value, selectedValue, type)

		if (newValue) onBlur(newValue)
	}

	handleOnChange = (selectedOption, type) => {
		const selectedValue =
			selectedOption && selectedOption.value ? selectedOption.value : null
		const { value, onChange } = this.props.input
		const newValue = getDateValue(value, selectedValue, type)

		if (newValue) onChange(newValue)
	}

	render() {
		const {
			input: { value },
			label,
			required,
			translate,
			disabled,
			disabledYear,
			children,
			meta: { touched, error },
			...props
		} = this.props
		const parts = value.split("/")
		const day = parts[0]
		const month = parts[1]
		let yearTime = parts[2].split(" ")
		let year = yearTime[0]

		return (
			<Translate>
				{(translate, activeLanguage) => (
					<div className="form-group">
						<div className="row mx--2">
							<div className="col-12 px-2">
								<label
									className="textbox_label textbox_label-primary font-sub color-text-2"
									data-required={required && !disabled}>
									{label}
									{" :"}
								</label>
							</div>
							<div
								className={classnames(
									"px-2",
									{ "col-5": disabledYear },
									{ "col-4": !disabledYear }
								)}>
								<Select
									value={day}
									placeholder={translate("_shared.form.label._day")}
									options={days}
									searchable={false}
									disabled={disabled}
									onChange={(option) =>
										this.handleOnChange(option, "day")
									}
									onBlur={() => this.handleOnBlur(day, "day")}
								/>
							</div>
							<div
								className={classnames(
									"px-2",
									{ "col-7": disabledYear },
									{ "col-4": !disabledYear }
								)}>
								<Select
									value={month}
									disabled={disabled}
									placeholder={translate("_shared.form.label._month")}
									options={
										activeLanguage.code !== "vi" ? months : vnMonths
									}
									searchable={false}
									onChange={(option) =>
										this.handleOnChange(option, "month")
									}
									onBlur={() => this.handleOnBlur(month, "month")}
								/>
							</div>
							{!disabledYear && (
								<div className="col-4 px-2">
									<Select
										value={year}
										placeholder={translate(
											"_shared.form.label._year"
										)}
										options={years}
										searchable={false}
										disabled={disabled}
										onChange={(option) =>
											this.handleOnChange(option, "year")
										}
										onBlur={() => this.handleOnBlur(year, "year")}
									/>
								</div>
							)}
							<ValidationMessage
								className={"px-2"}
								label={label}
								touched={touched}
								error={error}
								{...props}
							/>
						</div>
						{children}
					</div>
				)}
			</Translate>
		)
	}
}

DatePickerField.propTypes = {
	input: PropTypes.object.isRequired,
	label: PropTypes.string.isRequired,
	required: PropTypes.bool,
	meta: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
}

export default DatePickerField



// WEBPACK FOOTER //
// ./src/views/components/fields/DatePickerField.js